import React, { useRef, useState } from 'react';
import { getDevice } from '@panel/commons/helpers/device';
import { useOutsideClick } from '@panel/commons';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import {
  InputContainer,
  InputStyled,
  Label,
  MainContainer,
  TypeOption,
  TypeSelector,
  InputError,
  TypeSelectorOpContainer,
  Img
} from './styles';
import CheckIcon from '../../OptionButton/CheckIcon.js';
import Chevron from '../../../../assets/icons/chevron.svg';
import Alert from '../../../../assets/icons/alertIcon.svg';
import AlertMobile from '../../../../assets/icons/alertIconMobile.svg';

const InputWithTypeSelector = ({
  name = '',
  placeholder = '',
  type = 'text',
  typesOptions = [],
  label = '',
  width = '0px',
  typeSelectorPosition = 'right',
  error = null,
  onSelect = () => {},
  currentSelectorValue,
  currentValue = '',
  onInputChange = () => {},
  dataPubli = '',
  tooltipText = ''
}) => {
  const device = getDevice();
  const [isOpen, setIsOpen] = useState(false);
  const positionRef = useRef();

  const handleOnClick = value => {
    onSelect(value);
    setIsOpen(false);
  };

  useOutsideClick(positionRef, () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  const hasNumericValue = Boolean(currentValue && String(currentValue).length > 0);
  const hasTypeSelected = Boolean(currentSelectorValue);
  const isActive = hasNumericValue || hasTypeSelected || isOpen;

  return (
    <MainContainer width={width}>
      <Label device={device}>
        <div className='label-text' data-publi={`${dataPubli}-label`}>
          {label}
        </div>
        <SimpleTooltip
          position='top-center'
          text={tooltipText}
          dataPanel={`${dataPubli}-tooltip`}
          offset={8}
          backgroundColor='#3c3834'
          width={device === 'mobile' ? '150px' : '200px'}
          autoPlacements
        >
          <img src={device === 'desktop' ? Alert : AlertMobile} alt='Tooltip-icon' />
        </SimpleTooltip>
      </Label>
      <InputContainer typeSelectorPosition={typeSelectorPosition} error={error} isOpen={isOpen}>
        <InputStyled
          data-publi={`${dataPubli}-input`}
          placeholder={placeholder}
          type={type}
          name={name}
          onChange={e => {
            const value = e.target.value;
            const lastCharInserted = value[value.length - 1];
            const isNumeric = /^[0-9]$/.test(lastCharInserted);
            if (isNumeric) {
              onInputChange(value);
            } else {
              onInputChange(value.slice(0, -1));
            }
          }}
          value={currentValue}
        />
        <TypeSelector
          data-publi={`${dataPubli}-type-selector`}
          typeSelectorPosition={typeSelectorPosition}
          error={error}
          isOpen={isOpen}
          tabIndex={0}
          onClick={e => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setIsOpen(prev => !prev);
            }
          }}
        >
          {currentSelectorValue}
          <Img src={Chevron} alt='chevron' isOpen={isOpen} height={'16px'} />
        </TypeSelector>
        {isOpen && (
          <TypeSelectorOpContainer data-publi={`${dataPubli}-type-selector-options`} ref={positionRef}>
            {typesOptions?.map(option => {
              return (
                <TypeOption
                  name={name + 'Select'}
                  key={option.value}
                  onClick={() => handleOnClick(option.value)}
                  value={option.value}
                  isSelected={currentSelectorValue === option.label}
                  data-publi={`${dataPubli}-type-selector-option-${option.value}`}
                >
                  {option.label}
                  {currentSelectorValue === option.label && <CheckIcon />}
                </TypeOption>
              );
            })}
          </TypeSelectorOpContainer>
        )}
      </InputContainer>
      {error && <InputError data-publi={`${dataPubli}-error`}>{error}</InputError>}
    </MainContainer>
  );
};

export default InputWithTypeSelector;
